import { useState } from 'react';
import { Icon } from '@mui/material';
import { items, NAVIGATION_ITEMS } from './constants';
import { CustomBottomNavigation, CustomBottomNavigationAction, CustomPaper } from './style';
import { IBottomNavigationProps } from './types';

const BottomNavigation = ({
  fullWidth,
  conversationAction,
  contactsAction,
  settingsAction,
  currentActiveIndex,
}: IBottomNavigationProps) => {
  const fullWidthClass = fullWidth ? 'fullWidth' : '';

  const [activeIndex, setActiveIndex] = useState(currentActiveIndex);

  const handleChange = (index: number, action: () => void) => {
    setActiveIndex(index);
    action();
  };

  const ItemsToRender = items.map((item, index) => {
    let onClickAction;
    const isSelected = activeIndex === index;

    const itemClasses = [fullWidthClass, isSelected ? 'selected' : ''].join(' ');
    if (item.id === NAVIGATION_ITEMS.CONTACTS && !contactsAction) {
      return null;
    }
    if (item.id === NAVIGATION_ITEMS.CONVERSATION) {
      onClickAction = () => handleChange(index, conversationAction);
    } else if (item.id === NAVIGATION_ITEMS.SETTINGS) {
      onClickAction = () => handleChange(index, settingsAction);
    } else if (contactsAction) {
      onClickAction = () => handleChange(index, contactsAction);
    }
    return (
      <CustomBottomNavigationAction
        key={item.id}
        data-testid={item.id}
        disableRipple
        disableTouchRipple
        icon={<Icon className={item.icon} />}
        className={itemClasses}
        onClick={onClickAction}
      />
    );
  });

  return (
    <CustomPaper className={fullWidthClass} data-testid="BottomNavigationWrapper">
      <CustomBottomNavigation value={activeIndex} className={fullWidthClass}>
        {ItemsToRender}
      </CustomBottomNavigation>
    </CustomPaper>
  );
};

export default BottomNavigation;
